import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-score-faq-modal',
  templateUrl: './score-faq-modal.component.html',
  styleUrls: ['./score-faq-modal.component.css']
})
export class ScoreFaqModalComponent implements OnInit {

  faqData = [
    {
      title: '',
      description: 'Wondering what assessments are all about? We have got it covered. Here is a quick guide for all the assessment-related queries. Keep scrolling, the answers are right here!',
    },
    {
      title: 'What are Practice Exercises and Touchstones?',
      description: 'Practice Exercises and Touchstones are assessments that help you build your Course Score. You might want to spend some extra minutes reflecting on your responses while you are at it. ',
    },
    {
      title: 'What is Course Score?',
      description: 'Course Score refers to the overall score you get in the course. The maximum score is 100.',
    },
    {
      title: 'How does my score for each exercise contribute to my Course Score?',
      description: 'You will find the score contribution of each exercise mentioned on the screen before you start it. Once you finish the exercise and submit your responses, your  score will appear on the screen.',
    },
    {
      title: 'What metric is the Course Score based on?',
      description: 'Through the assessments, we are trying to get to know you better so we can give you constructive feedback to inculcate these behaviors. At Harappa, behaviors are a function of improving skills, making an effort and building confidence. These are the three measures we use for grading.',
    },
    {
      title: 'How is the scoring done?',
      description: 'We check for how well you have understood the course concepts and your ability to apply them. Your responses to the assessments are graded on a predefined scale, which is based on the type and difficulty of the question.',
    },
    {
      title: 'What if I answer a question partially correct?',
      description: 'In a question, we award partial scores for the options that are attempted correctly.',
    },
    {
      title: 'Who scores my open-ended responses?',
      description: 'Harappa Learning Specialists read your responses to open-ended questions and grade them based on a predefined rubric.',
    },
    {
      title: 'Can I take a second attempt at an exercise?',
      description: 'There is no provision for a second chance once you have attempted an exercise. So spend an extra minute on each question when you are submitting your response. Thinking twice before you submit your responses will also help you internalize the concepts better.',
    },
    {
      title: 'When can I see my Practice Exercise and Touchstone scores?',
      description: 'You can see your scores and feedback for a particular exercise as soon as you submit it. If the Touchstone exercise has an open-ended question that requires feedback from Harappa Learning Specialists, you will be notified accordingly.',
    },
    {
      title: 'When can I see my overall Course Score?',
      description: 'You will be able to see your Course Score and your breakup on Skill, Effort and Confidence after you finish all assessments. The scores for individual exercises can be seen on the dashboard after successfully submitting the exercises. ',
    },
    {
      title: 'When can I download my Harappa Certificate?',
      description: 'You get your certificate at the end of a course after successfully completing all the modules and assessments. You will be able to see your certificate once you have completed the course.',
    },
    {
      title: 'What should I do in case I have any other questions?',
      description: 'Don’t worry! We are just around the corner. Write your query on the Harappa Support Chat on the learning platform or you can email us at support@harappa.education. We are here to answer them.',
    }
];


  constructor(public activeModal: NgbActiveModal) { }


  ngOnInit() {
  }

  close() {
    this.activeModal.close();
  }

}
